import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'cpf-user-preview',
  templateUrl: './user-preview.component.html',
  styleUrls: ['./user-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class UserPreviewComponent {

}
